import { useLayoutEffect } from 'react';

function getWin(ele: HTMLElement) {
	return ele.ownerDocument.defaultView;
}

function collectScroller(ele: HTMLElement) {
	const scrollerList: HTMLElement[] = [];
	let current = ele?.parentElement;

	const scrollStyle = ['hidden', 'scroll', 'clip', 'auto'];

	while (current && current !== document.getElementById('pageContainer')) {
		const { overflowX, overflowY, overflow } = getWin(current)!.getComputedStyle(current);
		if ([overflowX, overflowY, overflow].some((o) => scrollStyle.includes(o))) {
			scrollerList.push(current);
		}

		current = current.parentElement;
	}

	return scrollerList;
}

export function useScrollDisabled(element: HTMLElement | null, controller: boolean) {
	useLayoutEffect(() => {
		if (controller && element) {
			const scrollList = collectScroller(element);
			const mergedList = new Set([...scrollList]);

			mergedList.forEach((element) => {
				element.classList.add('forceForbidScroll');
			});

			return () => {
				mergedList.forEach((element) => {
					element.classList.remove('forceForbidScroll');
				});
			};
		}
	}, [element, controller]);
}

export function useScrollHappen(element: HTMLElement | null, callback?: AnyFunc) {
	useLayoutEffect(() => {
		if (callback && element) {
			const scrollList = collectScroller(element);
			const mergedList = new Set([...scrollList]);

			mergedList.forEach((element) => {
				element.addEventListener('scroll', callback);
			});

			return () => {
				mergedList.forEach((element) => {
					element.removeEventListener('scroll', callback);
				});
			};
		}
	}, [element, callback]);
}

export default function useContainerWatch(
	open: boolean,
	onScroll: VoidFunction,
	target?: HTMLElement | null,
	popup?: HTMLElement | null,
) {
	useLayoutEffect(() => {
		if (open && target && popup) {
			const targetElement = target;
			const popupElement = popup;
			const targetScrollList = collectScroller(targetElement);
			const popupScrollList = collectScroller(popupElement);

			const win = getWin(popupElement);

			const mergedList = new Set([win, ...targetScrollList, ...popupScrollList]);

			const notifyScroll = () => {
				onScroll();
			};

			mergedList.forEach((scroller) => {
				scroller?.addEventListener('scroll', notifyScroll, { passive: true });
			});

			win?.addEventListener('resize', notifyScroll, { passive: true });
			onScroll();

			return () => {
				mergedList.forEach((scroller) => {
					scroller?.removeEventListener('scroll', notifyScroll);
					win?.removeEventListener('resize', notifyScroll);
				});
			};
		}
	}, [open, target, popup]);
}
